import { Select } from "antd";
import { ContentType, CONTENT_TYPE_LABELS } from "./fieldConfig";

interface ContentTypeSelectorProps {
  value: ContentType;
  onChange: (value: ContentType) => void;
  disabled?: boolean;
}

function ContentTypeSelector({
  value,
  onChange,
  disabled = false,
}: ContentTypeSelectorProps) {
  const options = (Object.keys(CONTENT_TYPE_LABELS) as ContentType[]).map(
    (key) => ({
      label: CONTENT_TYPE_LABELS[key],
      value: key,
    }),
  );

  return (
    <>
      <label className="uc-label" style={{ marginBottom: 0, marginRight: 8 }}>
        Content Type
      </label>
      <Select
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{ minWidth: 220 }}
        options={options}
        size="large"
      />
    </>
  );
}

export default ContentTypeSelector;
